import React, { useEffect, useState } from "react";
import axios from "axios";
import { useFormik } from "formik";
import { contactvalidation } from "../validation/Contactvalidation";
import aos from "aos"
import "aos/dist/aos.css"
import { ClipLoader } from 'react-spinners';
const Contactus = () => {
  const [loading, setloading] = useState("");
  const [response, setresponse] = useState({});
  const [success, setsuccess] = useState(false);
  
  useEffect(()=>{
    aos.init({duration:3000});
    });

// formik validation start here 
const initialValues = {
  fname: "",
  lname: "",
  mobile_no: "",
  emailID: "",
  message: ""
}
const {values,errors,handleBlur,handleChange,handleSubmit,touched} = useFormik({
  initialValues:initialValues,
  validationSchema:contactvalidation,
  onSubmit: async (values) =>{
    console.log("dfgd",values)
    setloading(true);
    const formdata = new FormData();
    formdata.append("fname", values.fname);
    formdata.append("lname", values.lname);
    formdata.append("mobile_no", values.mobile_no);
    formdata.append("emailID", values.emailID);
    formdata.append("message", values.message);
    try {
      let url = "https://backendwebmastery.onrender.com/contactus";
      const response = await axios.post(url, formdata);
      console.log(response.data);
      if(response.data.status == "sucessful"){
        setsuccess(true)

        setTimeout(() => {
          setsuccess(false)
        }, 4000);
      }
      setloading(false);
    } catch (error) {
      setresponse({
        statusone: 1,
        message: "Something Went Wrong Try again",
      });
      setloading(false);
    }

  }
})
// formik validation end here 

  async function submitform(e) {
    e.preventDefault();
    setloading(true);
    const formdata = new FormData();
    // formdata.append("fname", fname);
    // formdata.append("lname", lname);
    // formdata.append("mobile_no", mobile_no);
    // formdata.append("emailID", emailID);
    // formdata.append("message", message);
    try {
      let url = "https://backendwebmastery.onrender.com/contactus";
      const response = await axios.post(url, formdata);
      console.log(response);
      setloading(false);
    } catch (error) {
      setresponse({
        statusone: 1,
        message: "Something Went Wrong Try again",
      });
      setloading(false);
    }
  }
  return (
    <section className="contact-area page-section scroll-content" id="contact">
      <div className="custom-container">
        <div className="contact-content content-width">
          <div className="section-header">
            <h4
              className="subtitle scroll-animation"
              data-animation="fade_from_bottom"
            >
              <i className="las la-dollar-sign" /> contact
            </h4>
            <h1 className="scroll-animation" data-aos="fade-up"
     data-aos-anchor-placement="top-bottom" data-animation="fade_from_bottom">
              Let's Work <span>Together!</span>
            </h1>
          </div>
          <h3 className="scroll-animation" data-animation="fade_from_bottom">
            azy6049@gmail.com
          </h3>
          <p id="required-msg">* Marked fields are required to fill.</p>
          <form
            className="contact-form scroll-animation"
            data-animation="fade_from_bottom"
            onSubmit={handleSubmit}
          >
            <div
              className="alert alert-success messenger-box-contact__msg"
              style={{ display: "none" }}
              role="alert"
            >
              Your message was sent successfully.
            </div>
            <div className="row">
              <div className="col-md-6">
                <div className="input-group">
                  <label htmlFor="full-name">
                    first Name <sup>*</sup>
                  </label>
                  <input
                    type="text"
                    placeholder="Your Fist Name"
                    name="fname"
                    value={values.fname}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                  {errors.fname && touched.fname ? (<p style={{color:"red"}}>{errors.fname}</p>) : null}
                </div>
              </div>
              <div className="col-md-6">
                <div className="input-group">
                  <label htmlFor="full-name">
                    Last Name <sup>*</sup>
                  </label>
                  <input
                    type="text"
                    placeholder="Your Last Name"
                    name="lname"
                    value={values.lname}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                  {errors.lname && touched.lname ? (<p style={{color:"red"}}>{errors.lname}</p>) : null}

                </div>
              </div>
              <div className="col-md-6">
                <div className="input-group">
                  <label htmlFor="email">
                    Email <sup>*</sup>
                  </label>
                  <input
                    type="email"
                    placeholder="Your email adress"
                    name="emailID"
                    value={values.emailID}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                  {errors.emailID && touched.emailID ? (<p style={{color:"red"}}>{errors.emailID}</p>) : null}
                </div>
              </div>
              <div className="col-md-6">
                <div className="input-group">
                  <label htmlFor="phone-number">
                    phone <sup>*</sup>
                  </label>
                  <input
                    type="number"
                    placeholder="Your number phone"
                    name="mobile_no"
                    value={values.mobile_no}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                  {errors.mobile_no && touched.mobile_no ? (<p style={{color:"red"}}>{errors.mobile_no}</p>) : null}
                </div>
              </div>
              <div cla ssName="col-md-12">
                <div className="input-group">
                  <label htmlFor="message">
                    message <sup>*</sup>
                  </label>
                  <textarea
                    placeholder="Wrire your message here ..."
                    name="message"
                    value={values.message}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                  {errors.message && touched.message ? (<p style={{color:"red"}}>{errors.message}</p>) : null}
                </div>
              </div>
              {success == true ?  <div cla ssName="col-md-12">
                <div className="input-group" style={{background:"#00693e",borderRadius:"22px",marginBottom:"9px"}}>
   <p style={{margin:"0px",padding :"5px 20px",fontSize:"22px",fontWeight:"600",color:"white"}}>Successfully Added</p>
                </div>
              </div> : ''}
             
              <div className="col-md-12">
                <div className="input-group submit-btn-wrap">
                  {loading == true ? <button
                    className="theme-btn"
                    name="submittwo"
                    type="button"
                    id="submit-form"
                  >
                    <ClipLoader
  className='centerlo'
        color="white"
        loading={true}
        // cssOverride={override}
        size={30}
        aria-label="Loading Spinner"
        data-testid="loader"
      />
                  </button> : <button
                    className="theme-btn"
                    name="submit"
                    type="submit"
                    id="submit-form"
                  >
                    send message
                  </button>}
                  
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
};

export default Contactus;
